
export default class Resource {
    constructor(id, cscom) {
        if (!(this instanceof Resource)) {
            return new Resource(id, cscom);
        }
        this.cscom = cscom;
        this.id = id;

        if (this.id) {
            this.path = `/user-site-api/resources/${this.id}`;
        } else {
            this.path = `/user-site-api/resources`;
        }
    }

    get(data) {
        return this.cscom.req.get(this.path, null, data);
    }
    
    list(data) {
        return this.cscom.req.get(this.path, data);
    }

}
